import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isNotNumber',
    standalone: false
})
export class IsNotNumberPipe implements PipeTransform {
    transform(value: any): boolean {
        return isNaN(Number(value));
    }
}
